<template>
  <div class="bg-gray-100 min-h-screen p-8">
    <!-- Header Section -->
    <header class="text-center mb-10">
      <h1 class="text-3xl font-bold text-green-700">Home Care for Recovery</h1>
      <p class="text-gray-700 mt-2">Guidance on supporting a loved one’s recovery at home</p>
    </header>

    <!-- Section 1: Creating a Safe and Supportive Environment -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Creating a Safe and Supportive Environment</h2>
      <p class="text-gray-700">
        Providing a safe and nurturing environment is essential in supporting recovery. Remove any substances that may trigger cravings, maintain open communication, and encourage a positive, stress-free atmosphere to help your loved one feel secure.
      </p>
    </section>

    <!-- Section 2: Establishing a Healthy Routine -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Establishing a Healthy Routine</h2>
      <p class="text-gray-700">
        Structure and routine provide stability during recovery. Encourage regular daily activities such as balanced meals, exercise, and healthy sleep patterns. Consistent routines reduce stress and help build resilience.
      </p>
    </section>

    <!-- Section 3: Recognizing Signs of Relapse -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Recognizing Signs of Relapse</h2>
      <p class="text-gray-700">
        Being aware of potential relapse signs, such as mood swings, isolation, or neglecting responsibilities, can help with early intervention. Recognizing these signs early allows for timely support and guidance before setbacks occur.
      </p>
    </section>

    <!-- Section 4: Encouraging Ongoing Support and Counseling -->
    <section class="bg-green-50 rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Encouraging Ongoing Support and Counseling</h2>
      <p class="text-gray-700">
        Continued counseling and support group attendance are crucial for long-term recovery. Encourage participation in therapy sessions and meetings, which provide tools for managing triggers and reinforce commitment to recovery.
      </p>
    </section>

    <!-- Section 5: Educating Family Members -->
    <section class="bg-white rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold text-green-600 mb-4">Educating Family Members</h2>
      <p class="text-gray-700">
        Educating family members about addiction and recovery strengthens the support system. Attending family therapy sessions or support groups can help you understand recovery challenges and create a supportive home environment.
      </p>
    </section>

    <!-- Contact Information -->
    <section class="text-center mt-12">
      <p class="text-gray-700">For further guidance on home care support, reach out to us:</p>
      <p class="text-green-700 font-semibold mt-2">Email: tpccrecovery@gmail.com | Phone: 0746 298 500 / 0723 168 719</p>
    </section>
  </div>
</template>

<script>
export default {
  name: "HomeCare",
};
</script>

<style scoped>
/* Custom styles if needed */
</style>
